import React from 'react';
import Area from '@splunk/dashboard-visualizations/Area';

export default () => (
    <Area
        options={{
            'axisLabelsX.majorLabelStyle.rotation': 45,
        }}
        encoding={{
            x: 'primary.component',
            y: 'primary.count',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'component', groupby_rank: '0' }, { name: 'count' }],
                    columns: [
                        ['ApplicationLicense', 'DatabaseDirectoryManager', 'IndexWriter'],
                        ['166238', '8904', '2327'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
